import { CmtsReportCatalog } from "@components/reports/index.js";
import type { ComponentDiagnostic } from "@swot/base-components";

export type CmtsReportsPageProps = {
  readonly rows?: readonly Record<string, unknown>[] | undefined;
  readonly title?: string | undefined;
  readonly diagnostics?: readonly ComponentDiagnostic[] | undefined;
  readonly busy?: boolean | undefined;
  readonly error?: string | null | undefined;
  readonly onRunReport?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  readonly onExportReport?: ((row: Record<string, unknown>, format?: string) => void | Promise<void>) | undefined;
  readonly onOpenTypedReport?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  readonly onOpenExportHistory?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  readonly onPrintReport?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
};

export function CmtsReportsPage(_props: CmtsReportsPageProps) {
  return (
    <>
      <span className="sr-only">Backend report actions available after catalog selection: Export JSON, Export CSV, Print View.</span>
      <CmtsReportCatalog />
    </>
  );
}
